export default "__VITE_ASSET__H0dOoqiH__"